module.exports = __webpack_public_path__ + "img/zhiweb.1f8d367e.png";